import React from 'react';
import Icon from './Icon';
import './BottomNav.css';

const BottomNav = ({ activeTab, onTabChange }) => {
  const navItems = [
          {
            id: 'home',
            name: '首页',
            icon: 'shouye8',
            path: '/'
          },
          {
            id: 'library',
            name: '资料',
            icon: 'wendang',
            path: '/library'
          },
          {
            id: 'publish',
            name: '发布',
            icon: 'fabu',
            path: '/publish'
          },
          {
            id: 'notification',
            name: '通知',
            icon: 'xiaoxi',
            path: '/notification'
          },
          {
            id: 'profile',
            name: '我的',
            icon: 'gerenzhongxin1',
            path: '/profile'
          }
        ];

  const handleTabClick = (item) => {
    if (item.id === 'publish') {
      // 检查是否登录
      const token = localStorage.getItem('token');
      if (!token) {
        window.location.href = '/login';
      } else {
        window.location.href = item.path;
      }
    } else {
      // 普通标签页切换
      window.location.href = item.path;
      if (onTabChange) {
        onTabChange(item.id);
      }
    }
  };

  return (
    <nav className="bottom-nav">
      <div className="nav-container">
        {navItems.map((item) => (
          <div
            key={item.id}
            className={`nav-item ${activeTab === item.id ? 'active' : ''} ${item.id === 'publish' ? 'publish-item' : ''}`}
            onClick={() => handleTabClick(item)}
          >
            <div className="nav-icon">
              <Icon type={item.icon} />
            </div>
            <div className="nav-text">{item.name}</div>
          </div>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;